import React, { useState, useEffect } from 'react';

import {
  auth,
  provider,
  signInWithPopup,
  signInWithEmailAndPassword,
} from '../firebase';

import { createUserWithEmailAndPassword } from 'firebase/auth';
import { ensureUserDoc } from '../utils/ensureUserDoc'; // ← додаємо


/**
 * Модальне вікно авторизації.
 * Використання: <AuthModal open={open} onClose={()=>setOpen(false)} />
 */
export default function AuthModal({ open, onClose }) {
  const [email, setEmail] = useState('');
  const [pass, setPass]   = useState('');
  const [pass2, setPass2] = useState('');
  const [isSignup, setIsSignup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');
  // Автозакриття модалки, коли з’явився користувач
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape' && !loading) close(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, loading]);


  // Якщо модалка не відкрита АБО користувач уже залогінений — нічого не рендеримо
  if (!open || auth.currentUser) return null;

  const close = () => {
    setErr('');
    setEmail('');
    setPass('');
    setPass2('');
    setIsSignup(false);
    onClose?.();
  };



  const loginGoogle = async () => {
    let ok = false;
    try {
      setLoading(true);
      setErr('');
      const res = await signInWithPopup(auth, provider);
      await ensureUserDoc(res.user);
      ok = true;
    } catch (e) {
      console.error(e);
      setErr('Не вдалося увійти через Google');
    } finally {
      setLoading(false);
      if (ok) close();
    }
  };


  const loginEmail = async (e) => {
    e.preventDefault();
    let ok = false;
    try {
      setLoading(true);
      setErr('');
      if (!email || !pass) throw new Error('email/password required');
      const res = await signInWithEmailAndPassword(auth, email.trim(), pass);
      await ensureUserDoc(res.user);
      ok = true;
    } catch (e) {
      console.error(e);
      setErr('Помилка входу. Перевірте пошту та пароль.');
    } finally {
      setLoading(false);
      if (ok) close();
    }
  };

  const registerEmail = async (e) => {
    e.preventDefault();
    let ok = false;
    try {
      setLoading(true);
      setErr('');
      if (!email || !pass) throw new Error('email/password required');
      if (pass !== pass2) throw new Error('passwords mismatch');
      const res = await createUserWithEmailAndPassword(auth, email.trim(), pass);
      await ensureUserDoc(res.user);
      ok = true;
    } catch (e) {
      console.error(e);
      setErr(e.message === 'passwords mismatch'
        ? 'Паролі не співпадають.'
        : 'Не вдалося зареєструватися. Можливо, email вже використано.'
      );
    } finally {
      setLoading(false);
      if (ok) close();
    }
  };



  return (
    <div
      role="dialog"
      aria-modal="true"
      onClick={() => { if (!loading) close(); }}
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: 'rgba(0,0,0,.45)',
        display: 'grid', placeItems: 'center',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: 'clamp(320px, 92vw, 520px)',
          background: '#fff',
          borderRadius: 14,
          boxShadow: '0 12px 32px rgba(0,0,0,.18)',
          padding: 20,
        }}
      >
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
          <h2 style={{margin:0,fontSize:20}}>{isSignup ? 'Створити акаунт' : 'Вхід до акаунту'}</h2>
          <button onClick={close} style={{border:'none',background:'transparent',fontSize:20,cursor:'pointer'}}>×</button>
        </div>

        <button
          onClick={loginGoogle}
          disabled={loading}
          style={{
            width:'100%', padding:'10px 12px', borderRadius:8,
            border:'1px solid #e2e8f0', background:'#fff', cursor:'pointer',
            fontSize:16, marginBottom:12
          }}
        >
          Продовжити через Google
        </button>

        <div style={{opacity:.65, fontSize:13, margin:'6px 0'}}>або</div>

        <form onSubmit={isSignup ? registerEmail : loginEmail} style={{display:'grid', gap:10}}>
          <label style={{fontSize:13}}>Електронна пошта</label>
          <input
            type="email" value={email} onChange={e=>setEmail(e.target.value)}
            placeholder="you@example.com"
            style={{padding:'10px 12px', borderRadius:8, border:'1px solid #e2e8f0'}}
          />
          <label style={{fontSize:13}}>Пароль</label>
          <input
            type="password" value={pass} onChange={e=>setPass(e.target.value)}
            placeholder="••••••••"
            style={{padding:'10px 12px', borderRadius:8, border:'1px solid #e2e8f0'}}
          />
        
        {isSignup && (
          <>
            <label style={{fontSize:13}}>Підтвердження пароля</label>
            <input
              type="password"
              value={pass2}
              onChange={e=>setPass2(e.target.value)}
              placeholder="••••••••"
              style={{padding:'10px 12px', borderRadius:8, border:'1px solid #e2e8f0'}}
            />
          </>
        )}

          {err && <div style={{color:'#b91c1c', fontSize:13}}>{err}</div>}

          <button
            type="submit"
            disabled={loading}
            style={{
              marginTop:6, width:'100%',
              padding:'10px 12px', borderRadius:999,
              background:'#0b5226', color:'#fff',
              border:'none', cursor:'pointer', fontSize:16
            }}
          >
            {loading ? (isSignup ? 'Реєстрація…' : 'Вхід…') : (isSignup ? 'Зареєструватися' : 'Увійти')}
          </button>

          <div style={{marginTop:6, fontSize:13}}>
            {isSignup ? 'Вже маєте акаунт?' : 'Немає акаунту?'}{' '}
            <button
              type="button"
              onClick={() => { setIsSignup(s => !s); setErr(''); }}
              style={{border:'none', background:'transparent', color:'#0b5226', fontWeight:700, cursor:'pointer', padding:0}}
            >
              {isSignup ? 'Увійти' : 'Зареєструватися'}
            </button>
          </div>

        </form>
      </div>
    </div>
  );
}
